import Api from "../../apis/api";
import globalstorageapi from "../../global/GlobalStrorage";
import globalapi from "../../apis/apifactory";
export default {
  getprojectid() {
    return globalstorageapi.getProjectID();
   // return "14";
  },
  addParameterBySteps(varstep, varparms) {
    let varproject = this.getcurrentproject();
    let apiurl =
      "save_project_details/?project=" +
      varproject +
      "&step=" +
      varstep +
      "&" +
      varparms;
    
    return Api.get(apiurl);
  },

  gettheParameterByProjectStepSummaryForModelData() {
    return globalapi.gettheParameterByProjectStep("12");
  },
  gettheParameterByProjectStepSummaryForModelOutCome() {
    return globalapi.gettheParameterByProjectStep("13");
  },
  async get_model_data() {
    let apiurl = "model_coeff/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  get_model_dep_varlist() {
    let apiurl = "model_dep_varlist/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  get_model_indep_varlist() {
    let apiurl = "model_indep_varlist/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  get_model_params_alreadysaved() {
    let apiurl = "get_model_params/?format=json&project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  get_model_save(parms) {
    let apiurl = "model_save/?project="+this.getprojectid()+"&step=12&param=" + parms;
    
    return Api.get(apiurl);
  },
  get_model_save_offset_tbd(variable, group, coeff, tratio) {
    let apiurl =
      "model_save_offset/?project="+this.getprojectid()+"&isactive=1&isdisable=0&step=12&variable=" +
      variable +
      "&group=" +
      group +
      "&coeff=" +
      coeff +
      "&tratio=" +
      tratio +
      "";
    ////alert((apiurl);
    return Api.get(apiurl);
  },
  tbd_get_model_save_offset_remove(variable, group, coeff, tratio) {
    let apiurl =
      "model_save_offset/?project="+this.getprojectid()+"&isactive=0&isdisable=1&step=12&variable=" +
      variable +
      "&group=" +
      group +
      "&coeff=" +
      coeff +
      "&tratio=" +
      tratio +
      "";
    
    return Api.get(apiurl);
  },
  async tbd_get_model_offset() {
    let apiurl = "model_get_offset/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  async get_model_volume_pie12() {
    let apiurl = "model_volume_pie12/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  async get_model_volume_pie() {
    let apiurl = "model_volume_pie/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  async get_model_volume_area() {
    let apiurl = "model_volume_area/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  async get_model_dw() {
    let apiurl = "model_dw/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  async get_model_mape() {
    let apiurl = "model_mape/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  async get_model_adj_rsquared() {
    let apiurl = "model_adj_rsquared/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  async get_model_rsquared() {
    let apiurl = "model_rsquared/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  async get_model_aic_bic() {
    let apiurl = "model_aic_bic/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  //Actual vs Predicted with Error --Combined line & bar chart API
  async get_model_actual_predicted() {
    let apiurl = "model_actual_predicted/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  //modeloutcomes
  async get_model_roi_activity() {
    let apiurl = "model_roi_activity/?project="+this.getprojectid()+"&step=13";
    
    return Api.get(apiurl);
  },
  async get_model_roi_activity12() {
    let apiurl = "model_roi_activity12/?project="+this.getprojectid()+"&step=13";
    
    return Api.get(apiurl);
  },
  async get_model_roi_table() {
    let apiurl = "model_roi_table/?project="+this.getprojectid()+"&step=13";
    
    return Api.get(apiurl);
  },

  async get_roi_lcomb_varlist() {
    let apiurl = "roi_lcomb_varlist/?project="+this.getprojectid()+"&step=13";
    
    return Api.get(apiurl);
  },
  async get_get_roi_params() {
    let apiurl = "get_roi_params/?project="+this.getprojectid()+"&step=13";
    
    return Api.get(apiurl);
  },
  async get_save_roi_params(varparma) {
    let apiurl = "save_roi_params/?project="+this.getprojectid()+"&step=13&param="+ varparma;
    
    return Api.get(apiurl);
  },

  // new api
  api_get_model_offset() {
    //let apiurl = "model_get_offset/?project="+this.getprojectid()+"&step=12";
    let apiurl = "get_model_outcome/?project="+this.getprojectid()+"&step=12";
    
    return Api.get(apiurl);
  },
  api_get_model_dep_varlist() {
    let apiurl = "get_varlist_for_model/?project="+this.getprojectid()+"&step=6";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_get_model_save(parms) {
    let apiurl = "save_model_params/?project="+this.getprojectid()+"&param=" + parms;
    ////alert((apiurl);
    return Api.get(apiurl);
  },
  api_get_model_data() {
    let apiurl = "get_model_outcome/?project="+this.getprojectid()+"&step=6";
    //alert(apiurl);
    return Api.get(apiurl);
  },
  api_get_save_model_params() {
    let apiurl = "save_model_params/?project="+this.getprojectid()+"&step=6";
    
    return Api.get(apiurl);
  },
  api_get_model_save_offset(variable, group, coeff, tratio) {
    let apiurl =
      "save_model_offsets_params/?project="+this.getprojectid()+"&isactive=1&isdisable=0&step=6&variable=" +
      variable +
      "&region=" +
      group +
      "&coeff=" +
      coeff +
      "&tvalue=" +
      tratio +
      "";
    //alert(apiurl);
    return Api.get(apiurl);
  },
  api_get_model_save_offset_update(variable, group, coeff, tratio,recordid) {
    let apiurl =
      "save_model_offsets_params/?id="+recordid+"&project="+this.getprojectid()+"&isactive=1&isdisable=0&step=6&variable=" +
      variable +
      "&region=" +
      group +
      "&coeff=" +
      coeff +
      "&tvalue=" +
      tratio +
      "";
    //alert(apiurl);
    return Api.get(apiurl);
  },
  api_get_model_save_offset_remove(variable, group, coeff, tratio) {
    let apiurl =
      "save_model_offsets_params/?project="+this.getprojectid()+"&isactive=0&isdisable=1&step=6&variable=" +
      variable +
      "&region=" +
      group +
      "&coeff=" +
      coeff +
      "&tvalue=" +
      tratio +
      "";
    ////alert((apiurl);
    return Api.get(apiurl);
  },

  api_get_model_offset_saved() {
    let apiurl = "save_model_offsets_params/?project="+this.getprojectid();
   // alert(apiurl);
    return Api.get(apiurl);
  },
   api_get_model_actual_predicted() {
    let apiurl = "get_model_outcome/?project="+this.getprojectid()+"&step=6";
    
    return Api.get(apiurl);
  },
  api_get_vargrp_for_model() {
    let apiurl = "save_vargrp_for_model/?project="+this.getprojectid()+"&step=6";
    
    return Api.get(apiurl);
  },
  api_save_vargrp_for_model(varvariable,vargroup) {
    let apiurl = "save_vargrp_for_model/?project="+this.getprojectid()+"&step=6&variable="+varvariable+"&group="+ vargroup+"";
    
    return Api.get(apiurl);
  },
  api_get_save_roi_parameters() {
    let apiurl = "save_roi_parameters/?project="+this.getprojectid();
    
    return Api.get(apiurl);
  },
  api_get_save_roi_parameters_swap(varparma) {
    let apiurl = "save_roi_parameters/?project="+this.getprojectid()+"&param_type=swap&param="+varparma+"";
    
    return Api.get(apiurl);
  },
  api_get_save_roi_parameters_group(varparma,vargroupname) {
    let apiurl = "save_roi_parameters/?project="+this.getprojectid()+"&param_type=group&param="+varparma+"&group_name="+vargroupname+"";
    
    return Api.get(apiurl);
  },
  api_get_save_roi_parameters_group_edit(varparma,vargroupname,varid) {
    let apiurl = "save_roi_parameters/?project="+this.getprojectid()+"&param_type=group&param="+varparma+"&group_name="+vargroupname+"&id="+varid+"";
    
    return Api.get(apiurl);
  },
  api_save_model_final(){
    let apiurl = "save_model_outcome/?project="+this.getprojectid();
    
    return Api.get(apiurl);
  }

  ,
  api_save_project_complete(){
    let apiurl = "save_project/?id="+this.getprojectid()+"&status=Completed" ;
    ////alert((apiurl);
    return Api.get(apiurl);
  },
  // methods for Synergy b/w Activities
  api_synergy_between_variables_get(){
    let apiurl = "get_synergy_between_variables/?step=6&project="+this.getprojectid()+"" ;
    //alert(apiurl);
    return Api.get(apiurl);
  },
  api_synergy_between_variables_get_model_data() {
    let apiurl = "get_model_outcome/?project="+this.getprojectid()+"&step=6";
    //alert(apiurl);
    return Api.get(apiurl);
  },
  api_synergy_between_variables_save_roi_parameters_getbyid() {
    let apiurl = "save_roi_parameters/?project="+this.getprojectid();
    //alert(apiurl);
    return Api.get(apiurl);
  },
  api_Synergy_Activities_save_roi_parameters_addnew(varparam) {
    let apiurl = "save_roi_parameters/?param_type=synergy&project="+this.getprojectid()+"&&param="+varparam;
   // alert(apiurl);
    return Api.get(apiurl);
  },
  api_Synergy_Activities_save_roi_parameters_edit(varparam,varrecordid) {
    let apiurl = "save_roi_parameters/?param_type=synergy&project="+this.getprojectid()+"&&param="+varparam+"&id="+varrecordid;
    //alert(apiurl);
    return Api.get(apiurl);
  },
  
  api_get_project_region_list(){
    let apiurl = "get_project_region_list/?project="+this.getprojectid()+"" ;
    //alert(apiurl);
    return Api.get(apiurl);
  },

  // new data points 

  get_model_outcome_str() {
    let apiurl = "get_model_outcome_str/?project="+this.getprojectid()+"&step=6";
    
    return Api.get(apiurl);
  },

};
